export const companies: Array<{name: string, logo: string, website: string}> = [
  {
    name: 'Yurplan',
    logo: 'companies/yurplan-logo.svg?v=1',
    website: 'https://yurplan.com/',
  },
  {
    name: 'Weezevent',
    logo: 'companies/weezevent-logo.svg',
    website: 'https://weezevent.com/',
  },
  {
    name: 'Pims',
    logo: 'companies/pims-logo.svg?v=1',
    website: 'https://pims.io/',
  },
  {
    name: 'Billetweb',
    logo: 'companies/billetweb-logo.svg?v=1',
    website: 'https://www.billetweb.fr/',
  },
  {
    name: 'Festik',
    logo: 'companies/festik-logo.svg',
    website: 'https://www.festik.fr/',
  },
  {
    name: 'Delight',
    logo: 'companies/delight-logo.svg',
    website: 'https://delight-data.com/',
  },
  {
    name: 'Arenametrix',
    logo: 'companies/arenametrix-logo.png',
    website: 'https://arenametrix.com/',
  },
  {
    name: 'Wilout',
    logo: 'companies/wilout-logo.svg',
    website: 'https://wilout.com/',
  },
  {
    name: 'SoTicket',
    logo: 'companies/soticket-logo.png',
    website: 'http://www.socoop.fr/',
  },
  {
    name: 'Rodrigue',
    logo: 'companies/rodrigue-logo.png',
    website: 'https://rodrigue-solutions.com/',
  },
  {
    name: 'Supersoniks',
    logo: 'companies/supersoniks-logo.png',
    website: 'https://la-billetterie.net/',
  },
];
